

const Login = () => {
    return (<div>Not Found</div>)
}

export default Login;
